import React, { useEffect, useState, useCallback, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  MyModal,
} from "../../features/RadConnStyle";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { HttpJsonHeader } from "../../features/Environments";

import axios from "axios";

// Table component dependency
import BoostrapTable from "react-bootstrap-table-next";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

export default function SqlSearchTypeA(props) {
  const defaultColumns = [
    {
      dataField: "itemName",
      text: `ค้นข้อมูล`,
      sort: true,
      headerStyle: () => {
        return { backgroundColor: "black", width: "10%" };
      },
      style: { border: "none", color: "var(--table-text-color)" },
      //filter: textFilter(customTextFilter),
      // headerFormatter: headerTextBox,
    },
  ];

  const userDetail = useSelector((state) => state.user.detail);
  const [winState, setWinState] = props.winState;
  const [columns, setColumns] = useState(defaultColumns);
  const [data, setData] = useState([]);
  const objREF = useRef([]);

  //----------------------------------------------------------------------
  if (winState == null) {
    setWinState({
      size: "sm",
      show: false,
      fieldIdName: "",
      sql: {
        tableName: null,
        fields: [],
        criteriaFields: [],
        criteriaText: "",
        defaultCriteria: "",
        orderBy: [],
        maxRows: 1000,
      },
      action: (e) => {
        alert(e);
      },
    });
  }

  // useEffect(() => {
  //   console.log(data);
  // }, [data]);

  const closeWin = () => {
    setWinState((pv) => {
      return { ...pv, show: false };
    });
  };

  //----------------------------------------------------------------------
  //*
  useEffect(() => {
    if (!winState.show) return;

    setColumns([
      {
        dataField: "itemName",
        text: `ค้นข้อมูล${winState?.headerText}`,
        sort: true,
        headerStyle: () => {
          return { backgroundColor: "black", width: "10%" };
        },
        style: { border: "none", color: "var(--table-text-color)" },
        filter: textFilter(customTextFilter),
        // headerFormatter: headerTextBox,
      },
    ]);

    document.removeEventListener("dblclick", null); // (e)=>handleDobleClick(e),);
    getData();
    return () => {
      document.addEventListener("dblclick", null);
    };
  }, [winState]);

  //----------------------------------------------------------------------
  const handleDobleClick = useCallback(
    (e) => {
      e.preventDefault();
      console.log("SqlSearchType dblclick handle event");
    },
    [winState]
  );
  //----------------------------------------------------------------------
  const getData = () => {
    axios
      .post(
        process.env.REACT_APP_API + "api/web-search-helper/get-data",
        {
          Params: winState.sql,
          User: userDetail,
        },
        HttpJsonHeader
      )
      .then((res) => {
        if (res.data && res.data.data) {
          setData(res.data.data);
        }
      })
      .catch((err) => console.log(err));
  };
  //----------------------------------------------------------------------
  // column configuration

  const headerTextBox = (column, colIndex, { sortElement, filterElement }) => {
    return (
      <div style={{ flex: "1", display: "flex", backgroundColor: "#333333" }}>
        <input
          type="text"
          className="textbox-40h"
          style={{ textAlign: "center" }}
          ref={(el) => {
            objREF.current[column.dataField] = el;
          }}
        />
      </div>
    );
  };

  const customTextFilter = {
    placeholder: "ข้อความค้นหา",
  };

  // const columns = [
  //   {
  //     dataField: "itemName",
  //     text: `ค้นข้อมูล${winState?.headerText}`,
  //     sort: true,
  //     headerStyle: () => {
  //       return { backgroundColor: "black", width: "10%" };
  //     },
  //     style: { border: "none", color: "var(--table-text-color)" },
  //     filter: textFilter(customTextFilter),
  //     // headerFormatter: headerTextBox,
  //   },
  // ];

  //----------------------------------------------------------------------
  const rowEvents = {
    // onClick : {.....}
    onDoubleClick: (e, row, rowIndex) => {
      e.preventDefault();
      winState.action(row, winState);
    },
  };
  //----------------------------------------------------------------------
  return (
    <MyModal
      show={winState.show}
      size={winState.size ? winState.size : "sm"}
      onHide={closeWin}
      backdrop={true}
      centered={false}
    >
      <ModalBodyBlack>
        <BoostrapTable
          bootstrap4
          keyField="itemId"
          rowClasses={"table-next-rows-style"}
          data={data}
          columns={columns}
          striped
          hover
          condensed
          headerWrapperClasses="headerWrapper"
          // wrapperClasses="bs-table-wrapper"

          bordered={true}
          // pagination = {paginationFactory(PageOptions)}
          filter={filterFactory()}
          rowEvents={rowEvents}
          //selectRow = {selectRow}
          //ref={refTable}
        />
      </ModalBodyBlack>
      <ModalFooterBlack>
        {/* <Button variant="primary" onClick={winState.action} >Get Result</Button>              */}
        <Button variant="danger" onClick={() => closeWin()}>
          Close
        </Button>
      </ModalFooterBlack>
    </MyModal>
  );
}
//----------------------------------------------------------------------

const HBox = styled.div`
  /* padding: 3px; */
  display: flex;
  /* align-items: center; */
`;
